<p>
  {{ 'allergensReference' | translate }}
  <a [href]="regulationUrl" target="_blank" rel="noopener">{{ 'allergensRegulation' | translate }}</a>
</p>
<div class="list">
  <span *ngFor="let allergen of allergens">
    <app-allergen-icon [allergen]="allergen" [size]="18"></app-allergen-icon>
    {{ allergen | allergenTranslate }}
  </span>
</div>
